import dayjs from 'dayjs'

const todayDate = dayjs().format('YYYY-MM-DD')

const DEFAULT_PRODUCT_COMMISSION_RULES_BY_MARKET = {
  CN: [
    // {
    //   ruleValidDateBeg: todayDate,
    //   ruleValidDateEnd: '2099-12-31',
    //   ruleValid: true,
    //   ruleConditions: {
    //     contactCountryCds: ['CN'],
    //     tags: [],
    //     prodOids: [],
    //   },
    //   ruleRate: 0.02,
    // },
  ],
  HK: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['HK'],
        tags: ['TAG_5_1'],
        prodOids: []
      },
      ruleRate: 0
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['HK'],
        tags: ['TAG_2_1', 'TAG_2_2', 'TAG_2_3', 'TAG_2_4', 'TAG_2_5', 'TAG_3_2', 'TAG_3_5', 'TAG_5_4', 'TAG_6_3', 'TAG_6_5', 'TAG_6_6', 'TAG_6_7'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['HK'],
        tags: ['TAG_2_6', 'TAG_4_5', 'TAG_5_2', 'TAG_5_3'],
        prodOids: []
      },
      ruleRate: 0.035
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['HK'],
        tags: ['TAG_1_1', 'TAG_1_2', 'TAG_1_3', 'TAG_3_1', 'TAG_3_3', 'TAG_3_4', 'TAG_3_6', 'TAG_4_1', 'TAG_4_2', 'TAG_4_3', 'TAG_4_4', 'TAG_4_6', 'TAG_4_8', 'TAG_6_1', 'TAG_6_2', 'TAG_6_4'],
        prodOids: []
      },
      ruleRate: 0.05
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['HK'],
        tags: ['TAG_3_7', 'TAG_4_7', 'TAG_5_5'],
        prodOids: []
      },
      ruleRate: 0.08
    }
  ],
  ID: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['ID'],
        tags: ['TAG_2_5', 'TAG_3_7', 'TAG_4_5', 'TAG_5_2', 'TAG_5_4'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['ID'],
        tags: ['TAG_2_1', 'TAG_2_2', 'TAG_2_3', 'TAG_2_6', 'TAG_3_2', 'TAG_3_6', 'TAG_4_2', 'TAG_4_6', 'TAG_5_1', 'TAG_6_1'],
        prodOids: []
      },
      ruleRate: 0.04
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['ID'],
        tags: ['TAG_1_1', 'TAG_3_3', 'TAG_3_4', 'TAG_4_4', 'TAG_4_7', 'TAG_4_8', 'TAG_5_3'],
        prodOids: []
      },
      ruleRate: 0.06
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['ID'],
        tags: ['TAG_1_2', 'TAG_3_5'],
        prodOids: []
      },
      ruleRate: 0.08
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['ID'],
        tags: ['TAG_1_3', 'TAG_3_1', 'TAG_4_1', 'TAG_4_3', 'TAG_5_5'],
        prodOids: []
      },
      ruleRate: 0.1
    }
  ],
  JP: [
    // {
    //   ruleValidDateBeg: todayDate,
    //   ruleValidDateEnd: '2099-12-31',
    //   ruleValid: true,
    //   ruleConditions: {
    //     contactCountryCds: ['JP'],
    //     tags: [],
    //     prodOids: [],
    //   },
    //   ruleRate: 0.02,
    // },
  ],
  KK: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['*'],
        tags: ['TAG_2_1', 'TAG_2_2', 'TAG_2_3', 'TAG_2_5', 'TAG_2_6', 'TAG_3_3', 'TAG_5_2', 'TAG_6_3', 'TAG_6_4', 'TAG_6_7'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['*'],
        tags: ['TAG_3_2', 'TAG_3_4', 'TAG_3_5', 'TAG_3_6', 'TAG_4_1', 'TAG_4_6', 'TAG_5_4', 'TAG_6_1'],
        prodOids: []
      },
      ruleRate: 0.04
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['*'],
        tags: ['TAG_1_1', 'TAG_1_3', 'TAG_3_1', 'TAG_4_2', 'TAG_4_5', 'TAG_4_8', 'TAG_5_1'],
        prodOids: []
      },
      ruleRate: 0.06
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['*'],
        tags: ['TAG_1_2', 'TAG_2_4', 'TAG_4_3', 'TAG_4_4', 'TAG_4_7'],
        prodOids: []
      },
      ruleRate: 0.08
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['*'],
        tags: ['TAG_3_7', 'TAG_5_3', 'TAG_5_5'],
        prodOids: []
      },
      ruleRate: 0.1
    }
  ],
  AU: [
  ],
  KR: [
    // {
    //   ruleValidDateBeg: todayDate,
    //   ruleValidDateEnd: '2099-12-31',
    //   ruleValid: true,
    //   ruleConditions: {
    //     contactCountryCds: ['KR'],
    //     tags: [],
    //     prodOids: [],
    //   },
    //   ruleRate: 0.02,
    // },
  ],
  MY: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['MY'],
        tags: ['TAG_2_1', 'TAG_2_3', 'TAG_2_5', 'TAG_3_2', 'TAG_3_5', 'TAG_5_4', 'TAG_6_1', 'TAG_6_3'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['MY'],
        tags: ['TAG_1_1', 'TAG_2_4', 'TAG_2_6', 'TAG_3_3', 'TAG_4_6', 'TAG_5_1', 'TAG_5_2', 'TAG_5_3', 'TAG_6_2', 'TAG_6_4'],
        prodOids: []
      },
      ruleRate: 0.04
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['MY'],
        tags: ['TAG_1_2', 'TAG_1_3', 'TAG_2_2', 'TAG_3_6', 'TAG_3_7', 'TAG_4_1', 'TAG_4_2', 'TAG_4_3', 'TAG_4_5', 'TAG_4_7', 'TAG_4_8'],
        prodOids: []
      },
      ruleRate: 0.06
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['MY'],
        tags: ['TAG_3_1', 'TAG_3_4', 'TAG_4_4', 'TAG_5_5'],
        prodOids: []
      },
      ruleRate: 0.08
    }
  ],
  PH: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['PH'],
        tags: ['TAG_2_1', 'TAG_2_2', 'TAG_2_3', 'TAG_2_5', 'TAG_3_2', 'TAG_3_3', 'TAG_3_5', 'TAG_3_6', 'TAG_5_3', 'TAG_5_4'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['PH'],
        tags: ['TAG_1_2', 'TAG_1_3', 'TAG_2_4', 'TAG_2_6', 'TAG_3_7', 'TAG_5_2', 'TAG_6_1'],
        prodOids: []
      },
      ruleRate: 0.04
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['PH'],
        tags: ['TAG_1_1', 'TAG_3_1', 'TAG_4_3', 'TAG_4_4', 'TAG_4_5', 'TAG_4_6', 'TAG_4_8', 'TAG_5_1'],
        prodOids: []
      },
      ruleRate: 0.06
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['PH'],
        tags: ['TAG_3_4', 'TAG_4_1', 'TAG_4_7', 'TAG_5_5'],
        prodOids: []
      },
      ruleRate: 0.08
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['PH'],
        tags: ['TAG_4_2', 'TAG_6_4'],
        prodOids: []
      },
      ruleRate: 0.1
    }
  ],
  SG: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['SG'],
        tags: ['TAG_6_3', 'TAG_3_5', 'TAG_2_4', 'TAG_5_1', 'TAG_2_3', 'TAG_2_1'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['SG'],
        tags: ['TAG_3_4', 'TAG_6_1', 'TAG_1_1', 'TAG_2_6', 'TAG_3_6', 'TAG_2_5', 'TAG_5_3', 'TAG_5_2', 'TAG_4_5', 'TAG_4_1', 'TAG_2_2', 'TAG_3_3', 'TAG_5_4', 'TAG_4_6'],
        prodOids: []
      },
      ruleRate: 0.04
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['SG'],
        tags: ['TAG_3_2', 'TAG_1_3', 'TAG_3_1'],
        prodOids: []
      },
      ruleRate: 0.06
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['SG'],
        tags: ['TAG_4_8', 'TAG_4_7', 'TAG_1_2', 'TAG_6_4', 'TAG_4_3', 'TAG_4_2', 'TAG_3_7', 'TAG_5_5'],
        prodOids: []
      },
      ruleRate: 0.08
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['SG'],
        tags: ['TAG_4_4'],
        prodOids: []
      },
      ruleRate: 0.1
    }
  ],
  TH: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['TH'],
        tags: ['TAG_1_1', 'TAG_1_2', 'TAG_1_3', 'TAG_3_1', 'TAG_4_1', 'TAG_4_8'],
        prodOids: []
      },
      ruleRate: 0.04
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['TH'],
        tags: ['TAG_2_1', 'TAG_2_3', 'TAG_2_5', 'TAG_3_2', 'TAG_3_3', 'TAG_5_1', 'TAG_6_1'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['TH'],
        tags: ['TAG_4_5', 'TAG_4_6', 'TAG_4_7', 'TAG_5_2', 'TAG_5_3'],
        prodOids: []
      },
      ruleRate: 0.03
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['TH'],
        tags: ['TAG_3_4', 'TAG_6_4', 'TAG_4_2', 'TAG_4_3', 'TAG_4_4'],
        prodOids: []
      },
      ruleRate: 0.05
    }
  ],
  TW: [
    // {
    //   ruleValidDateBeg: todayDate,
    //   ruleValidDateEnd: '2099-12-31',
    //   ruleValid: true,
    //   ruleConditions: {
    //     contactCountryCds: ['TW'],
    //     tags: [],
    //     prodOids: [],
    //   },
    //   ruleRate: 0.02,
    // },
  ],
  VN: [
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['VN'],
        tags: ['TAG_1_2', 'TAG_1_3', 'TAG_2_1', 'TAG_2_3', 'TAG_3_1', 'TAG_3_4', 'TAG_3_5', 'TAG_5_1', 'TAG_5_3', 'TAG_6_1'],
        prodOids: []
      },
      ruleRate: 0.02
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['VN'],
        tags: ['TAG_1_1', 'TAG_2_2', 'TAG_2_4', 'TAG_2_5', 'TAG_3_2', 'TAG_3_3', 'TAG_3_7', 'TAG_4_1', 'TAG_4_3', 'TAG_4_5', 'TAG_5_2'],
        prodOids: []
      },
      ruleRate: 0.04
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['VN'],
        tags: ['TAG_3_6', 'TAG_4_2', 'TAG_4_4', 'TAG_4_6', 'TAG_4_7', 'TAG_4_8', 'TAG_5_4'],
        prodOids: []
      },
      ruleRate: 0.06
    },
    {
      ruleValidDateBeg: todayDate,
      ruleValidDateEnd: '2099-12-31',
      ruleValid: true,
      ruleConditions: {
        contactCountryCds: ['VN'],
        tags: ['TAG_2_6', 'TAG_5_5', 'TAG_6_3'],
        prodOids: []
      },
      ruleRate: 0.1
    }
  ]
}

const BPM_NOT_AVAILABLE_STATUS = [
  'CREATED', 'TO_DO', 'REQUESTING_PAYMENT', 'PAYMENT_DONE'
]

export default {
  CONTACT: {
    EMAIL: 'kkpartners@kkday.com',
    EMAIL_JA: 'kkpartners-jp@kkday.com',
    EMAIL_KO: 'affiliate-mkt2-kr@kkday.com'
  },
  DEFAULT_PRODUCT_COMMISSION_RULES_BY_MARKET,
  BPM_NOT_AVAILABLE_STATUS
}
